(function (Drupal, $) {
  Drupal.behaviors.stickyHeader = {
    attach: function attach(context) {
      const scrollCheck = () => {
        const scrollTop = $('section').first().height();

        if ($(window).scrollTop() > scrollTop) {
          $('header').addClass('sticky');
          $('body').addClass('sticky-header');
        } else {
          $('header').removeClass('sticky');
          $('body').removeClass('sticky-header');
        }
      }

      $(window).scroll(scrollCheck);
      $(window).ready(scrollCheck);

      let didScroll;
      let lastScrollTop = 0;
      let delta = 20;
      let navbarHeight = $('header').outerHeight();

      /*$(window).scroll(function(event){
        didScroll = true;
      });

      setInterval(function() {
        if (didScroll) {
          hasScrolled();
          didScroll = false;
        }
      }, 500);*/

      function hasScrolled() {

        const scrollTop = $(window).scrollTop();
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - scrollTop) <= delta)
          return;

        if (scrollTop > lastScrollTop && scrollTop > navbarHeight + 80){
          // Scroll Down
          $('header').removeClass('nav-down').addClass('nav-up');
        } else {
          // Scroll Up
          if(scrollTop + $(window).height() < $(document).height()) {
            $('header').removeClass('nav-up').addClass('nav-down');
          }
        }

        lastScrollTop = scrollTop;
      }
    }
  };
})(Drupal, jQuery);
